<template>
  <div>
    <Title :title="'总表电量及电价'" :isActiveSec="true"></Title>
    <Chart :cdata="cdata" :width="style.width" :height="style.height"/>
  </div>
</template>

<script>
import Chart from '../chart.vue';
import Title from '../../title';
import { siteLeft } from '@/api/singleSite/left';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      cdata: {
        category: [],
        rateData: [],
        id:"userAddChart",
        legendData:[],
        series:[
            {
              name: "电价",
              type: "line",
              smooth: true,

              symbolSize: 1,
              yAxisIndex: 1,
              itemStyle: {
                color: "#90F3FF" 
              },
              areaStyle: {
                color:new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#00FFFF" },
                    { offset: 1, color: "#010D44" }
                ]),
                opacity: 0.5
              },
              data: []
            },
            {
              name: "总表电量",
              type: "bar",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#36A1FF" },
                    { offset: 1, color: "#1968FF" }
                  ])
                }
              },
              data: []
            },
        ]
      },
      style:{
        width: '433',
        height: '180'
      }
    };
  },
  components: {
    Chart,
    Title,
  },
  mounted () {
    // this.cdata.category = [...Array(24).keys()];
  },
  methods: {
    getData(data){
      this.getStationNum(data);
    },
    getStationNum(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          "enCode":"genjustationidfanhuinum",
          "@station_id":data.stationId,
      })
        .then((res) => {
          if (!res) return;
          _this.selectStationNeedsAndBillNum(data,res[0].station_num)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //TiDB-站点-总表电量及电
    selectStationNeedsAndBillNum(data={},num){
      let _this = this;
			let params = {};
      params = {
        "enCode":"TiDB-zhandian-zongbiaodianliangjidianjia",
        "@station_num":num,
    		"@station_id":data.stationId
      }
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          console.log(res);
          let shiduan = [];
          let dianjia = [];
          let frequency = [];
						res.forEach(item=>{
              shiduan.push(item.shiduan);
              dianjia.push(item.price);
              frequency.push(item.elect_amount);
            })
          this.cdata.category = shiduan;
          
          this.cdata.series[0].data = dianjia;
          this.cdata.series[1].data = frequency;
          
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // selectStationNeedsAndBillNum(data={}){
    //   let _this = this;
    //   siteLeft
    //     .selectStationNeedsAndBillNum(data)
    //     .then((res) => {
    //       if(!res) return;
    //       this.cdata.series[0].data = res.billNumList;//订单数量
    //       let needsMap = res.needsList&&res.needsList[0];//需求
    //       const numsArr = ['one', 'two', 'three','four','five','six','seven','eight','nine','ten','eleven','twelve',"thirteen",'fourteen','fifteen','sixteen','seventeen','eighteen','nineteen','twenty','twentyone','twentytwo','twentythree','twentyfour'];
    //       const b = numsArr.map((key) => {
    //         return needsMap[`${key}col`];
    //       });
    //       this.cdata.series[1].data = b;

    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // }, 
  }
};
</script>

<style lang="scss" scoped>
</style>